var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.resource
    ? _c("div", [
        _vm.resource.master_name !== null &&
        (_vm.resource.type === "boolean" ||
          _vm.resource.name === "sex_id" ||
          _vm.resource.type === "radio")
          ? _c(
              "div",
              { staticClass: "d-flex flex-wrap" },
              _vm._l(
                _vm.addMasterNameDefault(
                  _vm.itemJob,
                  _vm.master,
                  _vm.resource.type
                ),
                function(item) {
                  return _c("div", { key: item.id, staticClass: "mr-2" }, [
                    item.show
                      ? _c(
                          "label",
                          { staticClass: "setting_form_radio_label" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.resource.default_value,
                                  expression: "resource.default_value"
                                }
                              ],
                              attrs: {
                                type: "radio",
                                id: item.id,
                                disabled: _vm.isDisableEditing
                              },
                              domProps: {
                                value: item,
                                checked: _vm._q(
                                  _vm.resource.default_value,
                                  item
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.resource,
                                    "default_value",
                                    item
                                  )
                                }
                              }
                            }),
                            item.choiceDisplayName
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "setting_form_radio_text",
                                    attrs: { for: item.id }
                                  },
                                  [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(item.choiceDisplayName) +
                                        "\n        "
                                    )
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass: "setting_form_radio_text",
                                    attrs: { for: item.id }
                                  },
                                  [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(item.choiceName) +
                                        "\n        "
                                    )
                                  ]
                                )
                          ]
                        )
                      : _vm._e()
                  ])
                }
              ),
              0
            )
          : _vm.resource.master_name !== null &&
            (_vm.resource.type === "single_select" ||
              _vm.resource.type === "select") &&
            _vm.resource.name !== "sex_id"
          ? _c("div", { staticClass: "d-flex flex-wrap setting_unit_form" }, [
              _c("div", { staticClass: "setting_unit_form" }, [
                _vm.master && _vm.master.length > 0
                  ? _c("div", { staticClass: "setting_form_select_wrapper" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.resource.default_value,
                              expression: "resource.default_value"
                            }
                          ],
                          staticClass: "setting_form_select",
                          attrs: { disabled: _vm.isDisableEditing },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.resource,
                                "default_value",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("---")
                          ]),
                          _vm._l(
                            _vm.master.filter(function(item) {
                              return item.show
                            }),
                            function(item) {
                              return _c(
                                "option",
                                { key: item.id, domProps: { value: item } },
                                [
                                  item.choiceDisplayName
                                    ? _c("span", [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(item.choiceDisplayName) +
                                            "\n            "
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(item.choiceName) +
                                            "\n            "
                                        )
                                      ])
                                ]
                              )
                            }
                          )
                        ],
                        2
                      )
                    ])
                  : _vm._e()
              ])
            ])
          : _vm.resource.master_name !== null &&
            (_vm.resource.type === "multi_select" ||
              _vm.resource.type === "checkbox")
          ? _c("div", [
              _vm.checkTypeOfArray(_vm.resource)
                ? _c(
                    "div",
                    { staticClass: "d-flex flex-wrap" },
                    [
                      _vm._l(_vm.master, function(item) {
                        return _c("div", { key: item.id, staticClass: "p-2" }, [
                          item.show
                            ? _c(
                                "label",
                                { staticClass: "jobs_form_label ml-2" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.resource.default_value,
                                        expression: "resource.default_value"
                                      }
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: item.id,
                                      disabled: _vm.isDisableEditing
                                    },
                                    domProps: {
                                      value: item,
                                      checked: Array.isArray(
                                        _vm.resource.default_value
                                      )
                                        ? _vm._i(
                                            _vm.resource.default_value,
                                            item
                                          ) > -1
                                        : _vm.resource.default_value
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.resource.default_value,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = item,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.resource,
                                                "default_value",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.resource,
                                                "default_value",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.resource,
                                            "default_value",
                                            $$c
                                          )
                                        }
                                      }
                                    }
                                  }),
                                  item.choiceDisplayName
                                    ? _c("span", { attrs: { for: item.id } }, [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(item.choiceDisplayName) +
                                            "\n          "
                                        )
                                      ])
                                    : _c("span", { attrs: { for: item.id } }, [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(item.choiceName) +
                                            "\n          "
                                        )
                                      ])
                                ]
                              )
                            : _vm._e()
                        ])
                      }),
                      _vm.itemJob
                        ? _c("div", { staticClass: "ml-auto p-2" }, [
                            _c(
                              "label",
                              { staticClass: "setting_form_radio_label ml-2" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.resource.multiSelectOption,
                                      expression: "resource.multiSelectOption"
                                    }
                                  ],
                                  attrs: { type: "radio", value: "1" },
                                  domProps: {
                                    checked: _vm._q(
                                      _vm.resource.multiSelectOption,
                                      "1"
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.resource,
                                        "multiSelectOption",
                                        "1"
                                      )
                                    }
                                  }
                                }),
                                _c(
                                  "span",
                                  { staticClass: "setting_form_radio_text" },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.labelProperties.AND) +
                                        "\n          "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "label",
                              { staticClass: "setting_form_radio_label ml-2" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.resource.multiSelectOption,
                                      expression: "resource.multiSelectOption"
                                    }
                                  ],
                                  attrs: { type: "radio", checked: "" },
                                  domProps: {
                                    value: undefined,
                                    checked: _vm._q(
                                      _vm.resource.multiSelectOption,
                                      undefined
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.resource,
                                        "multiSelectOption",
                                        undefined
                                      )
                                    }
                                  }
                                }),
                                _c(
                                  "span",
                                  { staticClass: "setting_form_radio_text" },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.labelProperties.OR) +
                                        "\n          "
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e()
            ])
          : _vm.resource.type === "textarea"
          ? _c(
              "div",
              [
                !_vm.itemJob
                  ? [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.resource.default_value,
                            expression: "resource.default_value"
                          }
                        ],
                        staticClass: "setting_form_textarea jobs_form_text",
                        attrs: {
                          type: _vm.resource.type,
                          disabled: _vm.isDisableEditing,
                          placeholder:
                            _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                        },
                        domProps: { value: _vm.resource.default_value },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.resource,
                                "default_value",
                                $event.target.value
                              )
                            },
                            function($event) {
                              return _vm.validateStringLengthInput(
                                _vm.itemJob,
                                _vm.resource
                              )
                            }
                          ]
                        }
                      })
                    ]
                  : _vm._e(),
                _vm.itemJob
                  ? [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.resource.default_value,
                            expression: "resource.default_value"
                          }
                        ],
                        staticClass:
                          "setting_form_text_customize jobs_form_text",
                        attrs: {
                          type: "text",
                          disabled: _vm.isDisableEditing,
                          placeholder:
                            _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                        },
                        domProps: { value: _vm.resource.default_value },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.resource,
                                "default_value",
                                $event.target.value
                              )
                            },
                            function($event) {
                              return _vm.validateStringLengthInput(
                                _vm.itemJob,
                                _vm.resource
                              )
                            }
                          ]
                        }
                      })
                    ]
                  : _vm._e(),
                !_vm.itemJob &&
                _vm.numberOfItem > 1 &&
                (_vm.resource.min_length || _vm.resource.max_length)
                  ? _c("span", { staticClass: "setting_range_allow_input" }, [
                      _vm._v(
                        _vm._s(_vm.labelPopupCustomizeProperties.WORD_COUNT) +
                          " " +
                          _vm._s(_vm.resource.min_length) +
                          " ~ " +
                          _vm._s(_vm.resource.max_length)
                      )
                    ])
                  : _vm._e(),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.resource.isMinLengthError,
                        expression: "resource.isMinLengthError"
                      }
                    ],
                    staticClass: "wrong-input"
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.resource.min_length) +
                        _vm._s(_vm.messagesProperties.MIN_LENGTH_ERROR)
                    )
                  ]
                ),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.resource.isMaxLengthError,
                        expression: "resource.isMaxLengthError"
                      }
                    ],
                    staticClass: "wrong-input"
                  },
                  [
                    _vm.resource.max_length
                      ? [_vm._v(_vm._s(_vm.resource.max_length))]
                      : _vm._e(),
                    !_vm.resource.max_length
                      ? [
                          _vm._v(
                            _vm._s(
                              _vm.messagesProperties.MAX_LENGTH_INPUT_TEXT_AREA
                            )
                          )
                        ]
                      : _vm._e(),
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.messagesProperties.MAX_LENGTH_ERROR)
                    )
                  ],
                  2
                )
              ],
              2
            )
          : _vm.resource.type === "datetime"
          ? _c("div", [
              _vm.itemJob
                ? _c(
                    "div",
                    { staticClass: "setting_form_input_from_to" },
                    [
                      _c("DatePicker", {
                        staticClass: "disabled-setting",
                        attrs: {
                          format: "YYYY/MM/DD HH:mm",
                          type: "datetime",
                          lang: _vm.jp,
                          disabled: _vm.isDisableEditing,
                          placeholder:
                            _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                        },
                        model: {
                          value: _vm.resource.default_value_from,
                          callback: function($$v) {
                            _vm.$set(_vm.resource, "default_value_from", $$v)
                          },
                          expression: "resource.default_value_from"
                        }
                      }),
                      _c(
                        "div",
                        { staticClass: "date_form_join_string" },
                        [
                          _c(
                            "font",
                            { staticStyle: { "vertical-align": "inherit" } },
                            [_vm._v("~")]
                          )
                        ],
                        1
                      ),
                      _c("DatePicker", {
                        staticClass: "disabled-setting",
                        attrs: {
                          format: "YYYY/MM/DD HH:mm",
                          type: "datetime",
                          lang: _vm.jp,
                          disabled: _vm.isDisableEditing,
                          placeholder:
                            _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                        },
                        model: {
                          value: _vm.resource.default_value_to,
                          callback: function($$v) {
                            _vm.$set(_vm.resource, "default_value_to", $$v)
                          },
                          expression: "resource.default_value_to"
                        }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("DatePicker", {
                        staticClass: "disabled-setting",
                        attrs: {
                          format: "YYYY/MM/DD HH:mm",
                          type: "datetime",
                          lang: _vm.jp,
                          disabled: _vm.isDisableEditing,
                          placeholder:
                            _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                        },
                        model: {
                          value: _vm.resource.default_value,
                          callback: function($$v) {
                            _vm.$set(_vm.resource, "default_value", $$v)
                          },
                          expression: "resource.default_value"
                        }
                      })
                    ],
                    1
                  )
            ])
          : _vm.resource.type === "time"
          ? _c("div", [
              _vm.itemJob
                ? _c(
                    "div",
                    { staticClass: "setting_form_input_from_to" },
                    [
                      _c("DatePicker", {
                        staticClass: "disabled-setting",
                        attrs: {
                          format: "HH:mm",
                          type: "time",
                          lang: _vm.jp,
                          disabled: _vm.isDisableEditing,
                          placeholder:
                            _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                        },
                        model: {
                          value: _vm.resource.default_value_from,
                          callback: function($$v) {
                            _vm.$set(_vm.resource, "default_value_from", $$v)
                          },
                          expression: "resource.default_value_from"
                        }
                      }),
                      _c(
                        "div",
                        { staticClass: "date_form_join_string" },
                        [
                          _c(
                            "font",
                            { staticStyle: { "vertical-align": "inherit" } },
                            [_vm._v("~")]
                          )
                        ],
                        1
                      ),
                      _c("DatePicker", {
                        staticClass: "disabled-setting",
                        attrs: {
                          format: "HH:mm",
                          type: "time",
                          lang: _vm.jp,
                          disabled: _vm.isDisableEditing,
                          placeholder:
                            _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                        },
                        model: {
                          value: _vm.resource.default_value_to,
                          callback: function($$v) {
                            _vm.$set(_vm.resource, "default_value_to", $$v)
                          },
                          expression: "resource.default_value_to"
                        }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("DatePicker", {
                        staticClass: "disabled-setting",
                        attrs: {
                          format: "HH:mm",
                          type: "time",
                          lang: _vm.jp,
                          disabled: _vm.isDisableEditing,
                          placeholder:
                            _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                        },
                        model: {
                          value: _vm.resource.default_value,
                          callback: function($$v) {
                            _vm.$set(_vm.resource, "default_value", $$v)
                          },
                          expression: "resource.default_value"
                        }
                      })
                    ],
                    1
                  )
            ])
          : _vm.resource.type === "date" && _vm.resource.name !== "birth_date"
          ? _c("div", [
              _vm.itemJob
                ? _c(
                    "div",
                    { staticClass: "setting_form_input_from_to" },
                    [
                      _c("DatePicker", {
                        staticClass: "disabled-setting",
                        attrs: {
                          format: "YYYY/MM/DD",
                          type: "date",
                          lang: _vm.jp,
                          disabled: _vm.isDisableEditing,
                          placeholder:
                            _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                        },
                        model: {
                          value: _vm.resource.default_value_from,
                          callback: function($$v) {
                            _vm.$set(_vm.resource, "default_value_from", $$v)
                          },
                          expression: "resource.default_value_from"
                        }
                      }),
                      _c(
                        "div",
                        { staticClass: "date_form_join_string" },
                        [
                          _c(
                            "font",
                            { staticStyle: { "vertical-align": "inherit" } },
                            [_vm._v("~")]
                          )
                        ],
                        1
                      ),
                      _c("DatePicker", {
                        staticClass: "disabled-setting",
                        attrs: {
                          format: "YYYY/MM/DD",
                          type: "date",
                          lang: _vm.jp,
                          disabled: _vm.isDisableEditing,
                          placeholder:
                            _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                        },
                        model: {
                          value: _vm.resource.default_value_to,
                          callback: function($$v) {
                            _vm.$set(_vm.resource, "default_value_to", $$v)
                          },
                          expression: "resource.default_value_to"
                        }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("DatePicker", {
                        staticClass: "disabled-setting",
                        attrs: {
                          format: "YYYY/MM/DD",
                          type: "date",
                          lang: _vm.jp,
                          disabled: _vm.isDisableEditing,
                          placeholder:
                            _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                        },
                        model: {
                          value: _vm.resource.default_value,
                          callback: function($$v) {
                            _vm.$set(_vm.resource, "default_value", $$v)
                          },
                          expression: "resource.default_value"
                        }
                      })
                    ],
                    1
                  )
            ])
          : _vm.resource.type === "ym"
          ? _c("div", [
              _vm.itemJob
                ? _c(
                    "div",
                    { staticClass: "setting_form_input_from_to" },
                    [
                      _c("DatePicker", {
                        staticClass: "disabled-setting",
                        attrs: {
                          format: "YYYY/MM",
                          type: "month",
                          lang: _vm.jp,
                          disabled: _vm.isDisableEditing,
                          "default-panel": "month",
                          placeholder:
                            _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                        },
                        model: {
                          value: _vm.resource.default_value_from,
                          callback: function($$v) {
                            _vm.$set(_vm.resource, "default_value_from", $$v)
                          },
                          expression: "resource.default_value_from"
                        }
                      }),
                      _c(
                        "div",
                        { staticClass: "date_form_join_string" },
                        [
                          _c(
                            "font",
                            { staticStyle: { "vertical-align": "inherit" } },
                            [_vm._v("~")]
                          )
                        ],
                        1
                      ),
                      _c("DatePicker", {
                        staticClass: "disabled-setting",
                        attrs: {
                          format: "YYYY/MM",
                          type: "month",
                          lang: _vm.jp,
                          disabled: _vm.isDisableEditing,
                          "default-panel": "month",
                          placeholder:
                            _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                        },
                        model: {
                          value: _vm.resource.default_value_to,
                          callback: function($$v) {
                            _vm.$set(_vm.resource, "default_value_to", $$v)
                          },
                          expression: "resource.default_value_to"
                        }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("DatePicker", {
                        staticClass: "disabled-setting",
                        attrs: {
                          format: "YYYY/MM",
                          type: "month",
                          lang: _vm.jp,
                          disabled: _vm.isDisableEditing,
                          "default-panel": "month",
                          placeholder:
                            _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                        },
                        model: {
                          value: _vm.resource.default_value,
                          callback: function($$v) {
                            _vm.$set(_vm.resource, "default_value", $$v)
                          },
                          expression: "resource.default_value"
                        }
                      })
                    ],
                    1
                  )
            ])
          : _vm.resource.name === "birth_date" && _vm.resource.type === "date"
          ? _c("div", [
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  staticClass:
                    "setting_form_text_customize input-date jobs_form_text",
                  attrs: {
                    type: "number",
                    id: "year",
                    min: "1900",
                    max: "5000",
                    disabled: _vm.isDisableEditing
                  },
                  domProps: { value: _vm.year },
                  on: {
                    change: function($event) {
                      return _vm.setYearToDefaultValue(
                        _vm.resource,
                        $event.target.value
                      )
                    }
                  }
                }),
                _c(
                  "label",
                  {
                    staticClass: "bold ml-3 mr-3 mt-2",
                    attrs: { for: "year" }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.labelsProperties.YEAR) +
                        "\n      "
                    )
                  ]
                ),
                _c("input", {
                  staticClass:
                    "setting_form_text_customize input-date jobs_form_text",
                  attrs: {
                    type: "number",
                    id: "month",
                    min: "1",
                    max: "12",
                    disabled: _vm.isDisableEditing
                  },
                  domProps: { value: _vm.month },
                  on: {
                    change: function($event) {
                      return _vm.setMonthToDefaultValue(
                        _vm.resource,
                        $event.target.value
                      )
                    }
                  }
                }),
                _c(
                  "label",
                  {
                    staticClass: "bold ml-3 mr-3 mt-2",
                    attrs: { for: "month" }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.labelsProperties.MONTH) +
                        "\n      "
                    )
                  ]
                ),
                _c("input", {
                  staticClass:
                    "setting_form_text_customize input-date jobs_form_text",
                  attrs: {
                    type: "number",
                    id: "day",
                    min: "1",
                    max: "31",
                    disabled: _vm.isDisableEditing
                  },
                  domProps: { value: _vm.day },
                  on: {
                    change: function($event) {
                      return _vm.setDateToDefaultValue(
                        _vm.resource,
                        $event.target.value
                      )
                    }
                  }
                }),
                _c(
                  "label",
                  { staticClass: "bold ml-3 mr-3 mt-2", attrs: { for: "day" } },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.labelsProperties.DAY) +
                        "\n      "
                    )
                  ]
                )
              ])
            ])
          : _vm.resource.type === "integer" ||
            _vm.resource.type === "calc" ||
            _vm.resource.type === "number"
          ? _c("div", [
              _vm.itemJob
                ? _c(
                    "div",
                    {
                      staticClass:
                        "setting_form_input_from_to jobs_table_form_unit"
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.resource.default_value_from,
                            expression: "resource.default_value_from"
                          }
                        ],
                        staticClass:
                          "setting_form_text_customize jobs_form_text",
                        attrs: {
                          type: "number",
                          disabled: _vm.isDisableEditing,
                          placeholder:
                            _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                        },
                        domProps: { value: _vm.resource.default_value_from },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.resource,
                              "default_value_from",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm.resource.unit
                        ? _c(
                            "span",
                            {
                              class: {
                                label_unit_item_long:
                                  _vm.resource.unit.length > 5,
                                label_unit_item: _vm.resource.unit.length <= 5
                              }
                            },
                            [_vm._v(_vm._s(_vm.resource.unit))]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "date_form_join_string" },
                        [
                          _c(
                            "font",
                            { staticStyle: { "vertical-align": "inherit" } },
                            [_vm._v("~")]
                          )
                        ],
                        1
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.resource.default_value_to,
                            expression: "resource.default_value_to"
                          }
                        ],
                        staticClass:
                          "setting_form_text_customize jobs_form_text",
                        attrs: {
                          type: "number",
                          disabled: _vm.isDisableEditing,
                          placeholder:
                            _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                        },
                        domProps: { value: _vm.resource.default_value_to },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.resource,
                              "default_value_to",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm.resource.unit
                        ? _c(
                            "span",
                            {
                              class: {
                                label_unit_item_long:
                                  _vm.resource.unit.length > 5,
                                label_unit_item: _vm.resource.unit.length <= 5
                              }
                            },
                            [_vm._v(_vm._s(_vm.resource.unit))]
                          )
                        : _vm._e()
                    ]
                  )
                : _c("div", { staticClass: "jobs_table_form_unit" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.resource.default_value,
                          expression: "resource.default_value"
                        }
                      ],
                      staticClass: "setting_form_text_customize jobs_form_text",
                      attrs: {
                        type: "number",
                        disabled: _vm.isDisableEditing,
                        placeholder:
                          _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                      },
                      domProps: { value: _vm.resource.default_value },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.resource,
                              "default_value",
                              $event.target.value
                            )
                          },
                          function($event) {
                            return _vm.validateNumberInput(
                              _vm.itemJob,
                              _vm.resource
                            )
                          }
                        ]
                      }
                    }),
                    _vm.resource.unit
                      ? _c(
                          "span",
                          {
                            class: {
                              label_unit_item_long:
                                _vm.resource.unit.length > 5,
                              label_unit_item: _vm.resource.unit.length <= 5
                            }
                          },
                          [_vm._v(_vm._s(_vm.resource.unit))]
                        )
                      : _vm._e()
                  ]),
              !_vm.itemJob &&
              _vm.numberOfItem > 1 &&
              (_vm.resource.min_length || _vm.resource.max_length)
                ? _c("span", { staticClass: "setting_range_allow_input" }, [
                    _vm._v(
                      _vm._s(_vm.labelPopupCustomizeProperties.RANGE) +
                        " " +
                        _vm._s(_vm.resource.min_length) +
                        " ~ " +
                        _vm._s(_vm.resource.max_length)
                    )
                  ])
                : _vm._e(),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.resource.isMinNumberError,
                      expression: "resource.isMinNumberError"
                    }
                  ],
                  staticClass: "wrong-input"
                },
                [
                  _vm._v(
                    _vm._s(_vm.resource.min_length) +
                      _vm._s(_vm.messagesProperties.MIN_NUMBER_ERROR)
                  )
                ]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.resource.isMaxNumberError,
                      expression: "resource.isMaxNumberError"
                    }
                  ],
                  staticClass: "wrong-input"
                },
                [
                  _vm._v(
                    _vm._s(_vm.resource.max_length) +
                      _vm._s(_vm.messagesProperties.MAX_NUMBER_ERROR)
                  )
                ]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.resource.isWrongDecimalPoint,
                      expression: "resource.isWrongDecimalPoint"
                    }
                  ],
                  staticClass: "wrong-input"
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.printf(
                          _vm.messagesProperties.WRONG_DECIMAL_POINT,
                          _vm.resource.length_step
                        )
                      ) +
                      "\n    "
                  )
                ]
              )
            ])
          : _vm.resource.type === "url"
          ? _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.resource.default_value,
                    expression: "resource.default_value"
                  }
                ],
                staticClass: "setting_form_text_customize jobs_form_text",
                attrs: {
                  type: "url",
                  disabled: _vm.isDisableEditing,
                  placeholder: _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                },
                domProps: { value: _vm.resource.default_value },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.resource,
                        "default_value",
                        $event.target.value
                      )
                    },
                    function($event) {
                      return _vm.checkInputURL(_vm.itemJob, _vm.resource)
                    }
                  ]
                }
              }),
              !_vm.itemJob &&
              _vm.numberOfItem > 1 &&
              (_vm.resource.min_length || _vm.resource.max_length)
                ? _c("span", { staticClass: "setting_range_allow_input" }, [
                    _vm._v(
                      _vm._s(_vm.labelPopupCustomizeProperties.WORD_COUNT) +
                        " " +
                        _vm._s(_vm.resource.min_length) +
                        " ~ " +
                        _vm._s(_vm.resource.max_length)
                    )
                  ])
                : _vm._e(),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.resource.wrongUrl,
                      expression: "resource.wrongUrl"
                    }
                  ],
                  staticClass: "wrong-input"
                },
                [_vm._v(_vm._s(_vm.messagesProperties.WRONG_INPUT_URL))]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.resource.isMinLengthError,
                      expression: "resource.isMinLengthError"
                    }
                  ],
                  staticClass: "wrong-input"
                },
                [
                  _vm._v(
                    _vm._s(_vm.resource.min_length) +
                      _vm._s(_vm.messagesProperties.MIN_LENGTH_ERROR)
                  )
                ]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.resource.isMaxLengthError,
                      expression: "resource.isMaxLengthError"
                    }
                  ],
                  staticClass: "wrong-input"
                },
                [
                  _vm._v(
                    _vm._s(_vm.resource.max_length) +
                      _vm._s(_vm.messagesProperties.MAX_LENGTH_ERROR)
                  )
                ]
              )
            ])
          : _vm.resource.type === "tel"
          ? _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.resource.default_value,
                    expression: "resource.default_value"
                  }
                ],
                staticClass: "setting_form_text_customize jobs_form_text",
                attrs: {
                  type: "text",
                  disabled: _vm.isDisableEditing,
                  placeholder: _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                },
                domProps: { value: _vm.resource.default_value },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.resource,
                        "default_value",
                        $event.target.value
                      )
                    },
                    function($event) {
                      return _vm.checkInputPhone(_vm.itemJob, _vm.resource)
                    }
                  ]
                }
              }),
              !_vm.itemJob &&
              _vm.numberOfItem > 1 &&
              (_vm.resource.min_length || _vm.resource.max_length)
                ? _c("span", { staticClass: "setting_range_allow_input" }, [
                    _vm._v(
                      _vm._s(_vm.labelPopupCustomizeProperties.WORD_COUNT) +
                        " " +
                        _vm._s(_vm.resource.min_length) +
                        " ~ " +
                        _vm._s(_vm.resource.max_length)
                    )
                  ])
                : _vm._e(),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.resource.wrongPhone,
                      expression: "resource.wrongPhone"
                    }
                  ],
                  staticClass: "wrong-input"
                },
                [_vm._v(_vm._s(_vm.messagesProperties.WRONG_INPUT_PHONE))]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.resource.isMinLengthError,
                      expression: "resource.isMinLengthError"
                    }
                  ],
                  staticClass: "wrong-input"
                },
                [
                  _vm._v(
                    _vm._s(_vm.resource.min_length) +
                      _vm._s(_vm.messagesProperties.MIN_LENGTH_ERROR)
                  )
                ]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.resource.isMaxLengthError,
                      expression: "resource.isMaxLengthError"
                    }
                  ],
                  staticClass: "wrong-input"
                },
                [
                  _vm._v(
                    _vm._s(_vm.resource.max_length) +
                      _vm._s(_vm.messagesProperties.MAX_LENGTH_ERROR)
                  )
                ]
              )
            ])
          : _vm.resource.type.includes("mail")
          ? _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.resource.default_value,
                    expression: "resource.default_value"
                  }
                ],
                staticClass: "setting_form_text_customize jobs_form_text",
                attrs: {
                  type: "text",
                  disabled: _vm.isDisableEditing,
                  placeholder: _vm.itemName + _vm.labelsProperties.PLACE_HOLDER
                },
                domProps: { value: _vm.resource.default_value },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.resource,
                        "default_value",
                        $event.target.value
                      )
                    },
                    function($event) {
                      return _vm.checkInputEmail(_vm.itemJob, _vm.resource)
                    }
                  ]
                }
              }),
              !_vm.itemJob &&
              _vm.numberOfItem > 1 &&
              (_vm.resource.min_length || _vm.resource.max_length)
                ? _c("span", { staticClass: "setting_range_allow_input" }, [
                    _vm._v(
                      _vm._s(_vm.labelPopupCustomizeProperties.WORD_COUNT) +
                        " " +
                        _vm._s(_vm.resource.min_length) +
                        " ~ " +
                        _vm._s(_vm.resource.max_length)
                    )
                  ])
                : _vm._e(),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.resource.wrongEmail,
                      expression: "resource.wrongEmail"
                    }
                  ],
                  staticClass: "wrong-input"
                },
                [_vm._v(_vm._s(_vm.messagesProperties.WRONG_INPUT_EMAIL))]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.resource.isMinLengthError,
                      expression: "resource.isMinLengthError"
                    }
                  ],
                  staticClass: "wrong-input"
                },
                [
                  _vm._v(
                    _vm._s(_vm.resource.min_length) +
                      _vm._s(_vm.messagesProperties.MIN_LENGTH_ERROR)
                  )
                ]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.resource.isMaxLengthError,
                      expression: "resource.isMaxLengthError"
                    }
                  ],
                  staticClass: "wrong-input"
                },
                [
                  _vm._v(
                    _vm._s(_vm.resource.max_length) +
                      _vm._s(_vm.messagesProperties.MAX_LENGTH_ERROR)
                  )
                ]
              )
            ])
          : _vm.resource.name === "photo"
          ? _c("div", [
              _c("div", { staticClass: "entry_uploader_item" }, [
                _c("div", { staticClass: "entry_uploader_holder" }, [
                  _c(
                    "p",
                    {
                      staticClass: "entry_uploader_number",
                      style: {
                        color:
                          _vm.draftColors && _vm.draftColors.pageText
                            ? _vm.draftColors.pageText
                            : ""
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.labelsProperties.FILE) +
                          ":\n        "
                      )
                    ]
                  ),
                  _c(
                    "label",
                    {
                      staticClass: "entry_uploader_label img_label ml-3",
                      style: [
                        {
                          color:
                            _vm.draftColors && _vm.draftColors.mainButtonText
                              ? _vm.draftColors.mainButtonText
                              : ""
                        },
                        {
                          backgroundColor:
                            _vm.draftColors && _vm.draftColors.mainButton
                              ? _vm.draftColors.mainButton
                              : ""
                        },
                        {
                          border:
                            _vm.draftColors && _vm.draftColors.borderColor
                              ? "1px solid" + _vm.draftColors.borderColor
                              : ""
                        }
                      ]
                    },
                    [
                      _c("input", {
                        ref: "fileupload",
                        attrs: {
                          type: "file",
                          disabled: _vm.isDisableEditing,
                          accept: "image/jpeg,image/png,image/gif"
                        },
                        on: {
                          change: function($event) {
                            return _vm.handleUploadImage($event.target)
                          }
                        }
                      }),
                      _c("span", { staticClass: "entry_uploader_label_name" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.labelsProperties.SELECT_FILE) +
                            "\n          "
                        )
                      ])
                    ]
                  ),
                  _vm.file && _vm.file.name
                    ? _c("p", {
                        staticClass: "entry_uploader_name",
                        domProps: { textContent: _vm._s(_vm.file.name) }
                      })
                    : _c(
                        "p",
                        { staticClass: "entry_uploader_name is_disabled" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.labelsProperties.NOT_SELECTED_FILE) +
                              "\n        "
                          )
                        ]
                      )
                ]),
                _c(
                  "div",
                  {
                    staticClass: "entry_uploader_delete",
                    on: {
                      click: function($event) {
                        return _vm.handleDeleteImage()
                      }
                    }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "entry_uploader_delete_btn",
                        class:
                          _vm.file.name && !_vm.isDisableEditing
                            ? ""
                            : "is_disabled"
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "16",
                              height: "16",
                              viewBox: "0 0 1024 1024"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M876.8 140.8s6.4 3.2-86.4-22.4c-83.2-25.6-160-32-160-32L624 48c-3.2-28.8-25.6-48-51.2-48H451.2c-25.6 0-48 19.2-51.2 44.8l-6.4 38.4s-80 6.4-160 32c-92.8 28.8-86.4 25.6-86.4 25.6-22.4 3.2-35.2 25.6-35.2 48v32h800v-32c0-22.4-12.8-44.8-35.2-48zM176 928c3.2 54.4 48 96 102.4 96h464c54.4 0 99.2-41.6 102.4-96L896 272H124.8L176 928zm508.8-508.8c0-16 16-28.8 32-28.8s28.8 16 28.8 32l-28.8 480c0 16-16 28.8-32 28.8s-28.8-16-28.8-32l28.8-480zM480 422.4c0-16 12.8-32 32-32 16 0 32 12.8 32 32v480c0 16-12.8 32-32 32-16 0-32-12.8-32-32v-480zm-172.8-32c16 0 32 12.8 32 28.8l28.8 480c0 16-12.8 32-28.8 32s-32-12.8-32-28.8l-28.8-480c0-16 12.8-28.8 28.8-32z"
                              }
                            })
                          ]
                        ),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.labelsProperties.DELETE_FILE) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                )
              ]),
              _c(
                "p",
                {
                  staticClass: "jobs_table_annotation mt-3",
                  style: {
                    color:
                      _vm.draftColors && _vm.draftColors.pageText
                        ? _vm.draftColors.pageText
                        : ""
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.labelsProperties.SPECIFY_PHOTO_FORMAT) +
                      "\n    "
                  )
                ]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.extentionError,
                      expression: "extentionError"
                    }
                  ],
                  staticClass: "wrong-input"
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.messagesProperties.FILE_EXTENTION_ERROR) +
                      "\n    "
                  )
                ]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.overSize,
                      expression: "overSize"
                    }
                  ],
                  staticClass: "wrong-input"
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.messagesProperties.OVER_SIZE_ERROR) +
                      "\n    "
                  )
                ]
              )
            ])
          : _vm.resource.name === "files"
          ? _c(
              "div",
              [
                _vm._l(_vm.files, function(file, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "entry_uploader_item" },
                    [
                      _c("div", { staticClass: "entry_uploader_holder" }, [
                        _c(
                          "p",
                          {
                            staticClass: "entry_uploader_number",
                            style: {
                              color:
                                _vm.draftColors && _vm.draftColors.pageText
                                  ? _vm.draftColors.pageText
                                  : ""
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(file.name + (index + 1)) +
                                ":\n        "
                            )
                          ]
                        ),
                        _c(
                          "label",
                          {
                            staticClass: "entry_uploader_label ml-3",
                            style: [
                              {
                                color:
                                  _vm.draftColors &&
                                  _vm.draftColors.mainButtonText
                                    ? _vm.draftColors.mainButtonText
                                    : ""
                              },
                              {
                                backgroundColor:
                                  _vm.draftColors && _vm.draftColors.mainButton
                                    ? _vm.draftColors.mainButton
                                    : ""
                              },
                              {
                                border:
                                  _vm.draftColors && _vm.draftColors.borderColor
                                    ? "1px solid" + _vm.draftColors.borderColor
                                    : ""
                              }
                            ]
                          },
                          [
                            _c("input", {
                              ref: "attachment-" + index,
                              refInFor: true,
                              attrs: {
                                type: "file",
                                disabled: _vm.isDisableEditing
                              },
                              on: {
                                change: function($event) {
                                  return _vm.handleUploadFile(
                                    index,
                                    $event.target.name,
                                    $event.target.files
                                  )
                                }
                              }
                            }),
                            _c(
                              "span",
                              { staticClass: "entry_uploader_label_name" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(file.buttonUpload) +
                                    "\n          "
                                )
                              ]
                            )
                          ]
                        ),
                        file.content && file.content.name
                          ? _c("p", { staticClass: "entry_uploader_name" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(file.content.name) +
                                  "\n        "
                              )
                            ])
                          : _c(
                              "p",
                              {
                                staticClass: "entry_uploader_name is_disabled"
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(file.placeholder) +
                                    "\n        "
                                )
                              ]
                            )
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "entry_uploader_delete",
                          on: {
                            click: function($event) {
                              return _vm.deleteFile(index)
                            }
                          }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "entry_uploader_delete_btn",
                              class:
                                file.content.name && !_vm.isDisableEditing
                                  ? ""
                                  : "is_disabled"
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 1024 1024"
                                  }
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d:
                                        "M876.8 140.8s6.4 3.2-86.4-22.4c-83.2-25.6-160-32-160-32L624 48c-3.2-28.8-25.6-48-51.2-48H451.2c-25.6 0-48 19.2-51.2 44.8l-6.4 38.4s-80 6.4-160 32c-92.8 28.8-86.4 25.6-86.4 25.6-22.4 3.2-35.2 25.6-35.2 48v32h800v-32c0-22.4-12.8-44.8-35.2-48zM176 928c3.2 54.4 48 96 102.4 96h464c54.4 0 99.2-41.6 102.4-96L896 272H124.8L176 928zm508.8-508.8c0-16 16-28.8 32-28.8s28.8 16 28.8 32l-28.8 480c0 16-16 28.8-32 28.8s-28.8-16-28.8-32l28.8-480zM480 422.4c0-16 12.8-32 32-32 16 0 32 12.8 32 32v480c0 16-12.8 32-32 32-16 0-32-12.8-32-32v-480zm-172.8-32c16 0 32 12.8 32 28.8l28.8 480c0 16-12.8 32-28.8 32s-32-12.8-32-28.8l-28.8-480c0-16 12.8-28.8 28.8-32z"
                                    }
                                  })
                                ]
                              ),
                              _vm._v(
                                "\n          " +
                                  _vm._s(file.buttonDelete) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                }),
                _c(
                  "p",
                  {
                    staticClass: "jobs_table_annotation mt-3",
                    style: {
                      color:
                        _vm.draftColors && _vm.draftColors.pageText
                          ? _vm.draftColors.pageText
                          : ""
                    }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.labelsProperties.MAX_FILE_SIZE_ALLOW) +
                        "\n    "
                    )
                  ]
                ),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.overSize,
                        expression: "overSize"
                      }
                    ],
                    staticClass: "wrong-input"
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.messagesProperties.OVER_SIZE_ERROR) +
                        "\n    "
                    )
                  ]
                )
              ],
              2
            )
          : _c("div", [
              _vm.resource.type === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.resource.default_value,
                        expression: "resource.default_value"
                      }
                    ],
                    staticClass: "setting_form_text_customize jobs_form_text",
                    attrs: {
                      disabled: _vm.isDisableEditing,
                      placeholder:
                        _vm.itemName + _vm.labelsProperties.PLACE_HOLDER,
                      type: "checkbox"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.resource.default_value)
                        ? _vm._i(_vm.resource.default_value, null) > -1
                        : _vm.resource.default_value
                    },
                    on: {
                      input: function($event) {
                        return _vm.validateStringLengthInput(
                          _vm.itemJob,
                          _vm.resource
                        )
                      },
                      change: function($event) {
                        var $$a = _vm.resource.default_value,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.resource,
                                "default_value",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.resource,
                                "default_value",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.resource, "default_value", $$c)
                        }
                      }
                    }
                  })
                : _vm.resource.type === "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.resource.default_value,
                        expression: "resource.default_value"
                      }
                    ],
                    staticClass: "setting_form_text_customize jobs_form_text",
                    attrs: {
                      disabled: _vm.isDisableEditing,
                      placeholder:
                        _vm.itemName + _vm.labelsProperties.PLACE_HOLDER,
                      type: "radio"
                    },
                    domProps: {
                      checked: _vm._q(_vm.resource.default_value, null)
                    },
                    on: {
                      input: function($event) {
                        return _vm.validateStringLengthInput(
                          _vm.itemJob,
                          _vm.resource
                        )
                      },
                      change: function($event) {
                        return _vm.$set(_vm.resource, "default_value", null)
                      }
                    }
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.resource.default_value,
                        expression: "resource.default_value"
                      }
                    ],
                    staticClass: "setting_form_text_customize jobs_form_text",
                    attrs: {
                      disabled: _vm.isDisableEditing,
                      placeholder:
                        _vm.itemName + _vm.labelsProperties.PLACE_HOLDER,
                      type: _vm.resource.type
                    },
                    domProps: { value: _vm.resource.default_value },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.resource,
                            "default_value",
                            $event.target.value
                          )
                        },
                        function($event) {
                          return _vm.validateStringLengthInput(
                            _vm.itemJob,
                            _vm.resource
                          )
                        }
                      ]
                    }
                  }),
              !_vm.itemJob &&
              _vm.numberOfItem > 1 &&
              (_vm.resource.min_length || _vm.resource.max_length)
                ? _c(
                    "span",
                    {
                      staticClass:
                        "setting_range_allow_input modify_setting_range"
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.labelPopupCustomizeProperties.WORD_COUNT) +
                          " " +
                          _vm._s(_vm.resource.min_length) +
                          " ~ " +
                          _vm._s(_vm.resource.max_length)
                      )
                    ]
                  )
                : _vm._e(),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.resource.isMinLengthError,
                      expression: "resource.isMinLengthError"
                    }
                  ],
                  staticClass: "wrong-input"
                },
                [
                  _vm._v(
                    _vm._s(_vm.resource.min_length) +
                      _vm._s(_vm.messagesProperties.MIN_LENGTH_ERROR)
                  )
                ]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.resource.isMaxLengthError,
                      expression: "resource.isMaxLengthError"
                    }
                  ],
                  staticClass: "wrong-input"
                },
                [
                  _vm.resource.max_length
                    ? [_vm._v(_vm._s(_vm.resource.max_length))]
                    : _vm._e(),
                  !_vm.resource.max_length && _vm.resource.type === "text"
                    ? [
                        _vm._v(
                          _vm._s(_vm.messagesProperties.MAX_LENGTH_INPUT_TEXT)
                        )
                      ]
                    : _vm._e(),
                  _vm._v(
                    "\n      " + _vm._s(_vm.messagesProperties.MAX_LENGTH_ERROR)
                  )
                ],
                2
              )
            ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }